import { useEffect } from 'react';
import * as amplitude from '@amplitude/analytics-browser';

import { REACH_PAGE_EVENTS } from '@app/dashboard/constants/tracking_events/reach';

import Header from './Header';
import TableListing from './TableListing';

import styles from './Campaigns.module.scss';

const Campaigns = () => {
  useEffect(() => {
    amplitude.track(REACH_PAGE_EVENTS.CAMPAIGNS_PAGE.VIEW_CAMPAIGNS_PAGE);
  }, []);

  return (
    <div className={styles['campaigns']}>
      
      <Header />
      <TableListing />
    </div>
  );
};

export default Campaigns;
